import React from "react";
import "../static/intro.css";

const Intro = () => {
  return (
    <div className="intro-container">
      <p>
        Hello! Welcome to version one of the spotify song recommender! Please
        log in and select a genre to get recommendations and add them to a
        playlist on spotify.
      </p>
    </div>
  );
};

export default Intro;
